import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock } from "lucide-react";
import { api } from "../../lib/api";
import { useAuthStore } from "../../store/authStore";

function chip(daysLeft) {
  if (daysLeft === null || daysLeft === undefined)
    return { text: "—", cls: "bg-zinc-100 text-zinc-500" };
  if (daysLeft < 0)
    return { text: `${-daysLeft} gün gecikti`, cls: "bg-red-100 text-red-700" };
  if (daysLeft === 0) return { text: "BUGÜN", cls: "bg-red-100 text-red-700" };
  if (daysLeft <= 3)
    return { text: `${daysLeft} gün kaldı`, cls: "bg-amber-100 text-amber-700" };
  return { text: `${daysLeft} gün kaldı`, cls: "bg-emerald-100 text-emerald-700" };
}

export default function UpcomingDeadlinesCard() {
  const { tenant } = useAuthStore();
  const hasExpo = Array.isArray(tenant?.enabled_features)
    ? tenant.enabled_features.includes("expo")
    : false;
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (!hasExpo) return;
    api
      .get("/expo/upcoming-deadlines?days=14")
      .then(({ data }) => setItems(data))
      .catch(() => setItems([]));
  }, [hasExpo]);

  if (!hasExpo || !items || items.length === 0) return null;

  return (
    <div
      className="rounded-xl border border-zinc-200 bg-white p-4 shadow-sm"
      data-testid="upcoming-deadlines-card"
    >
      <h3 className="flex items-center gap-2 text-sm font-semibold text-zinc-900">
        <CalendarClock className="h-4 w-4 text-amber-600" />
        Yaklaşan Terminler
        <span className="rounded-full bg-amber-50 px-2 py-0.5 text-[11px] font-medium text-amber-700">
          {items.length}
        </span>
      </h3>
      <ul className="mt-3 space-y-2">
        {items.slice(0, 8).map((it) => {
          const c = chip(it.days_left);
          return (
            <li key={it.task_id}>
              <Link
                to={`/app/projects/${it.project_id}`}
                className="flex items-center gap-2 rounded-lg px-2 py-1.5 transition-colors hover:bg-zinc-50"
                data-testid={`deadline-item-${it.task_id}`}
              >
                <span className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-semibold ${c.cls}`}>
                  {c.text}
                </span>
                <span className="min-w-0 flex-1 truncate text-sm text-zinc-800">{it.title}</span>
                <span className="hidden shrink-0 text-[11px] text-zinc-400 sm:block">
                  {[it.project_name, it.fair_name].filter(Boolean).join(" · ")}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
